import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-update-organization-unit',
  templateUrl: './update-organization-unit.component.html',
  styleUrls: ['./update-organization-unit.component.scss'],
})
export class UpdateOrganizationUnitComponent {
  name = '';

  constructor(
    private dialogRef: MatDialogRef<UpdateOrganizationUnitComponent>,
    @Inject(MAT_DIALOG_DATA) data,
  ) {
    this.name = data.organizationUnit.niceName;
  }

  async save() {
    this.dialogRef.close(this.name);
  }
}
